import {
  createBaseAsyncHandlers,
  createStartAction,
  initialState,
} from 'app/api/redux-util/async-helpers';
import {
  ALL_ASSIGNMENTS,
  DELETE_ASSIGNMENT,
} from 'app/api/redux-feeny/assignments/actions';
import { removeFromArray } from 'app/utils/array';
import { createReducer } from 'app/api/redux-util/general-helpers';

const baseHandlers = createBaseAsyncHandlers(ALL_ASSIGNMENTS);

const deleteHandlers = {
  [createStartAction(DELETE_ASSIGNMENT).type]: (state, action) => {
    if (!state.data) {
      return state;
    }

    return {
      ...state,
      data: {
        data: removeFromArray(state.data.data, 'uuid', action.data[0]),
      },
    };
  },
};

export default createReducer(initialState, baseHandlers, deleteHandlers);



// WEBPACK FOOTER //
// ./src/app/api/redux-feeny/assignments/reducer.js